export default __webpack_public_path__ + "i18n/translation-fr.d08f7db3.json";